import { render, staticRenderFns } from "./CreatedAccount.vue?vue&type=template&id=2e7fd540&"
import script from "./CreatedAccount.vue?vue&type=script&lang=ts&"
export * from "./CreatedAccount.vue?vue&type=script&lang=ts&"
import style0 from "./CreatedAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports